import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Avatar, Badge, Box, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';
import { getSupportAgents } from '../../services/userservice'; // <-- ajusta o caminho se necessário

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': { transform: 'scale(.8)', opacity: 1 },
    '100%': { transform: 'scale(2.4)', opacity: 0 },
  },
}));

function formatarNomeOuEmail(nomeOuEmail) {
  if (!nomeOuEmail) return '';
  if (nomeOuEmail.includes('@')) return nomeOuEmail;
  const partes = nomeOuEmail.trim().split(' ');
  if (partes.length === 1) return partes[0];
  return `${partes[0]} ${partes[partes.length - 1]}`;
}

function BoxAtendente({ atendente }) {
  const theme = useTheme();
  const nomeFormatado = formatarNomeOuEmail(
    atendente?.name || atendente?.nome || atendente?.email
  );
  const [fotoPerfil, setFotoPerfil] = useState(null);

  useEffect(() => {
    let isMounted = true; // flag para saber se o componente segue montado

    const buscarFoto = async () => {
      try {
        const data = await getSupportAgents();

        const match = data.find(
          (u) =>
            u.uid === atendente?.uid ||
            u.email === atendente?.email ||
            u.nome === atendente?.name
        );

        if (isMounted) {
          if (match?.foto) {
            setFotoPerfil(match.foto);
          } else if (atendente?.avatar) {
            setFotoPerfil(atendente.avatar);
          }
        }
      } catch (err) {
        console.error('Erro ao buscar foto do atendente:', err);
        if (isMounted && atendente?.avatar) setFotoPerfil(atendente.avatar);
      }
    };

    if (atendente) {
      buscarFoto();
    }

    return () => {
      isMounted = false;
    };
  }, [atendente]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        p: 0.5,
        mb: 0.5,
        borderRadius: 1,
        background: theme.palette.gradients.dark,
      }}
    >
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
      >
        <Avatar
          alt={nomeFormatado}
          src={fotoPerfil || '/default-avatar.png'}
          sx={{ width: 30, height: 30 }}
        />
      </StyledBadge>

      <Box sx={{ ml: 2, maxWidth: '170px' }}>
        <Typography
          variant="subtitle2"
          title={nomeFormatado}
          sx={{
            color: 'text.primary',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {nomeFormatado}
        </Typography>
      </Box>
    </Box>
  );
}

export default BoxAtendente;
